<template>
  <v-autocomplete
    v-model="searchModel"
    :items="items"
    :loading="searchLoading"
    :search-input.sync="search"
    hide-selected
    hide-no-data
    placeholder="Search"
    item-text="description"
    item-value="item"
    dense
    filled
    clearable
    return-object
  />
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'OmniSearch',
  data: () => ({
    entries: [],
    searchLoading: false,
    searchModel: null,
    search: null,
    timerId: null,
  }),
  computed: {
    fields() {
      if (!this.searchModel) {
        return [];
      }

      return Object.keys(this.searchModel).map((key) => ({
        key,
        value: this.searchModel[key] || 'n/a',
      }));
    },
    items() {
      return this.entries.map((entry) => {
        let description = `${entry.type}: ${entry.name} `;

        if (entry.description !== null && entry.description !== undefined && entry.description !== '') {
          description = `${description} - ${entry.description}`;
        }

        return { ...entry, description };
      });
    },
  },
  watch: {
    search(val) {
      this.searchDebounced(val);
    },
    searchModel(val) {
      this.goToSelection(val);
    },
  },
  methods: {
    ...mapActions('apiClient', ['get']),
    searchDebounced(query) {
      clearTimeout(this.timerId);

      this.timerId = setTimeout(() => {
        this.doSearch(query);
      }, 300);
    },
    async doSearch(query) {
      if (!query) {
        return;
      }

      this.searchLoading = true;

      await this.get({ url: '/search', params: { q: query } }).then(
        (response) => {
          this.entries = response.data;
        },
        (error) => {
          console.log(error);
        },
      );

      this.searchLoading = false;
    },
    goToSelection(val) {
      switch (val.type) {
        case 'Inventory':
          this.$router.push({ name: 'inventoryEdit', params: { itemId: val.id } });
          break;
        case 'Client':
          this.$router.push({ name: 'clientEdit', params: { clientId: val.id } });
          break;
        case 'Manufacturer':
          this.$router.push({ name: 'mfgEdit', params: { mfgId: val.id } });
          break;
        default:
          console.log('Unsupported type');
      }
    },
  },
};
</script>
